export default __webpack_public_path__ + "static/gum-e75734136146bb15737fe322411006fe.jpg";